import { Observable } from 'rxjs'
import { MbQuoteInfoModel } from '../../../models'

export abstract class MbCheckoutQuoteInfoAdapter {

  abstract post(quoteInfoDetails: MbQuoteInfoModel, cartID: string): Observable<any>
}
